import React, { useMemo } from 'react'
import ReactECharts from 'echarts-for-react'

const MetricsTrendChart = ({ trend, runtimeURI }) => {
  const option = useMemo(() => {
    if (!trend || trend.length === 0) {
      return null
    }

    // Prepare time series data
    const timestamps = trend.map((sample) => new Date(sample.timestamp).toLocaleTimeString())
    const inputCountData = trend.map((sample) => sample.inputCount)
    const inputCountDeltaData = trend.map((sample) => sample.inputCountDelta)
    const scheduleDepthData = trend.map((sample) => sample.scheduleDepth)
    const throughputData = trend.map((sample) => (sample.inputCountDelta ?? 0) / 5)

    return {
      backgroundColor: 'transparent',
      title: {
        text: `Metrics Trend (${runtimeURI ?? 'Unknown'}) - Last ${trend.length} samples`,
        left: 'center',
        textStyle: {
          color: '#c9d1d9',
          fontSize: 16,
          fontWeight: 600,
        },
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(13, 17, 23, 0.95)',
        borderColor: 'rgba(88, 166, 255, 0.5)',
        textStyle: {
          color: '#c9d1d9',
        },
      },
      legend: {
        data: ['Throughput (events/s)', 'Input Delta', 'Schedule Depth'],
        top: 35,
        textStyle: {
          color: '#8b949e',
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        top: 80,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: timestamps,
        axisLine: {
          lineStyle: {
            color: 'rgba(88, 166, 255, 0.3)',
          },
        },
        axisLabel: {
          color: '#8b949e',
          fontSize: 11,
        },
      },
      yAxis: {
        type: 'value',
        axisLine: {
          lineStyle: {
            color: 'rgba(88, 166, 255, 0.3)',
          },
        },
        axisLabel: {
          color: '#8b949e',
          fontSize: 11,
        },
        splitLine: {
          lineStyle: {
            color: 'rgba(88, 166, 255, 0.1)',
          },
        },
      },
      series: [
        {
          name: 'Throughput (events/s)',
          type: 'line',
          smooth: true,
          data: throughputData,
          itemStyle: {
            color: '#58a6ff',
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: 'rgba(88, 166, 255, 0.3)' },
                { offset: 1, color: 'rgba(88, 166, 255, 0.05)' },
              ],
            },
          },
        },
        {
          name: 'Input Delta',
          type: 'line',
          smooth: true,
          data: inputCountDeltaData,
          itemStyle: {
            color: '#56d364',
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: 'rgba(86, 211, 100, 0.3)' },
                { offset: 1, color: 'rgba(86, 211, 100, 0.05)' },
              ],
            },
          },
        },
        {
          name: 'Schedule Depth',
          type: 'line',
          smooth: true,
          data: scheduleDepthData,
          itemStyle: {
            color: '#f778ba',
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: 'rgba(247, 120, 186, 0.3)' },
                { offset: 1, color: 'rgba(247, 120, 186, 0.05)' },
              ],
            },
          },
        },
      ],
    }
  }, [trend, runtimeURI])

  if (!option) {
    return (
      <div className="metrics-chart-placeholder">
        <p>No trend data available yet. Data will appear as metrics are collected.</p>
      </div>
    )
  }

  return (
    <ReactECharts
      option={option}
      style={{ height: '400px', width: '100%' }}
      opts={{ renderer: 'canvas' }}
      notMerge={true}
      lazyUpdate={true}
    />
  )
}

export default MetricsTrendChart
